import { useEffect, useState } from "react";
import { useIsPaneOpen, usePanes } from "../../../main/panes/usePanes";
import TableDisplayFieldsPane from "./tableDisplayFieldsPane/TableDisplayFieldsPane";
import { TableDisplayFieldsPaneProps } from "./tableDisplayFieldsPane/TableDisplayFieldsPane.types";
import { createTableDisplayFieldsStore } from "./tableDisplayFieldsStore";
import type { TableDisplayFieldsProps } from "./TableDisplayFields";

export default function useTableDisplayFields(props: TableDisplayFieldsProps) {
    const [store] = useState(() => createTableDisplayFieldsStore(props));
    // Built once from the store, so the unmount effect below can depend on it without re-running.
    const [isOwnPane] = useState(() => (paneProps: TableDisplayFieldsPaneProps) => paneProps.store === store);
    const { open, requestClosePane } = usePanes();
    const isPaneOpen = useIsPaneOpen(TableDisplayFieldsPane, isOwnPane);

    useEffect(() => store.setListProps(props));

    // The pane outlives the list it configures, so leaving the list closes it rather than leaving it editing
    // columns nobody can see.
    useEffect(() => () => requestClosePane(TableDisplayFieldsPane, isOwnPane), [requestClosePane, isOwnPane]);

    function togglePane() {
        if (isPaneOpen) {
            requestClosePane(TableDisplayFieldsPane, isOwnPane);
        } else {
            open(TableDisplayFieldsPane, { store });
        }
    }

    return { togglePane };
}
